import Contracts from './Contracts';

export default Contracts;
